import React, { useState } from 'react'
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material'
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material'
import CustomerLayout from '@/components/Layout/CustomerLayout'
import { useCustomerAuth } from '@/context/CustomerAuthContext'

export const AddressBookPage: React.FC = () => {
  const { savedAddresses, addSavedAddress, removeSavedAddress } = useCustomerAuth()
  const [openDialog, setOpenDialog] = useState(false)
  const [form, setForm] = useState({
    Title: '',
    Name: '',
    Furigana: '',
    Phone: '',
    PostalCD: '',
    PrefectureName: '',
    CityName: '',
    Address1: '',
    Address2: '',
  })

  const handleSaveNew = () => {
    addSavedAddress(
      {
        Name: form.Name,
        Furigana: form.Furigana,
        Phone: form.Phone,
        PostalCD: form.PostalCD,
        PrefectureName: form.PrefectureName,
        CityName: form.CityName,
        Address1: form.Address1,
        Address2: form.Address2,
      },
      form.Title || `${form.Name}様宛`
    )
    setOpenDialog(false)
    setForm({ Title: '', Name: '', Furigana: '', Phone: '', PostalCD: '', PrefectureName: '', CityName: '', Address1: '', Address2: '' })
  }

  return (
    <CustomerLayout>
      <Box sx={{ maxW: 1000, mx: 'auto' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box>
            <Typography variant="h4" fontWeight={700} sx={{ color: '#0f172a' }}>
              マイ配送先一覧（アドレス帳）
            </Typography>
            <Typography variant="body2" color="text.secondary">
              「異なる住所に送る」で保存されたお届け先の履歴一覧です。次回注文時に選択できます。
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setOpenDialog(true)}
            sx={{ bgcolor: '#2563eb', textTransform: 'none', fontWeight: 600 }}
          >
            新しい配送先を追加
          </Button>
        </Box>

        <Grid container spacing={3}>
          {savedAddresses.map((addr) => (
            <Grid item xs={12} sm={6} key={addr.UserConsigneeId}>
              <Card elevation={0} sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '100%' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="h6" fontWeight={700}>
                        {addr.Title}
                      </Typography>
                      {addr.IsDefault && <Chip label="既定" size="small" color="primary" />}
                    </Box>
                    <IconButton size="small" color="error" onClick={() => removeSavedAddress(addr.UserConsigneeId)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
                    {addr.Consignee?.Address?.Name} 様 ({addr.Consignee?.Address?.Furigana})
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    〒{addr.Consignee?.Address?.PostalCD}<br />
                    {addr.Consignee?.Address?.PrefectureName} {addr.Consignee?.Address?.CityName}{' '}
                    {addr.Consignee?.Address?.Address1} {addr.Consignee?.Address?.Address2}<br />
                    TEL: {addr.Consignee?.Address?.Phone}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* 新規登録モーダルダイアログ */}
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle fontWeight={700}>新しい配送先を登録</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2} sx={{ pt: 1 }}>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="タイトル (例: 実家, 友人A様)" value={form.Title} onChange={(e) => setForm({ ...form, Title: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth size="small" label="お名前" value={form.Name} onChange={(e) => setForm({ ...form, Name: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth size="small" label="フリガナ" value={form.Furigana} onChange={(e) => setForm({ ...form, Furigana: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth size="small" label="電話番号" value={form.Phone} onChange={(e) => setForm({ ...form, Phone: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth size="small" label="郵便番号" value={form.PostalCD} onChange={(e) => setForm({ ...form, PostalCD: e.target.value })} />
              </Grid>
              <Grid item xs={4}>
                <TextField fullWidth size="small" label="都道府県" value={form.PrefectureName} onChange={(e) => setForm({ ...form, PrefectureName: e.target.value })} />
              </Grid>
              <Grid item xs={8}>
                <TextField fullWidth size="small" label="市区町村" value={form.CityName} onChange={(e) => setForm({ ...form, CityName: e.target.value })} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth size="small" label="町名・番地・建物名" value={form.Address1} onChange={(e) => setForm({ ...form, Address1: e.target.value })} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>キャンセル</Button>
            <Button variant="contained" onClick={handleSaveNew} sx={{ bgcolor: '#2563eb' }}>登録する</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </CustomerLayout>
  )
}
export default AddressBookPage
